/*
 * Purpose: Mission workspace sub-navigation — P3
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import { PRODUCT_TERMS } from '@/lib/productTerms';

export type MissionSection = 'map' | 'operate' | 'insights' | 'settings';

export interface MissionNavItem {
  id: string;
  label: string;
  href: string;
  section: MissionSection;
}

export const MISSION_SECTIONS: { id: MissionSection; label: string }[] = [
  { id: 'map', label: PRODUCT_TERMS.mission },
  { id: 'operate', label: 'Operate' },
  { id: 'insights', label: 'Insights' },
  { id: 'settings', label: 'Settings' },
];

export const MISSION_NAV: MissionNavItem[] = [
  { id: 'map', label: PRODUCT_TERMS.mission, href: '/mission/map', section: 'map' },
  { id: 'scheduler', label: 'Scheduler', href: '/mission/operate/scheduler', section: 'operate' },
  { id: 'monitor', label: 'Monitor', href: '/mission/operate/monitor', section: 'operate' },
  { id: 'debug', label: 'Debug', href: '/mission/operate/debug', section: 'operate' },
  { id: 'analytics', label: 'Analytics', href: '/mission/insights/analytics', section: 'insights' },
  { id: 'logs', label: 'Logs', href: '/mission/insights/logs', section: 'insights' },
  { id: 'activity', label: 'Activity', href: '/mission/insights/activity', section: 'insights' },
  { id: 'stats', label: 'Stats', href: '/mission/insights/stats', section: 'insights' },
  { id: 'flow-settings', label: 'Flow settings', href: '/mission/settings/flow', section: 'settings' },
  { id: 'versions', label: 'Versions', href: '/mission/settings/versions', section: 'settings' },
  { id: 'share', label: 'Share', href: '/mission/settings/share', section: 'settings' },
];

export function matchMissionSection(pathname: string): MissionSection {
  if (pathname.includes('/operate')) return 'operate';
  if (pathname.includes('/insights')) return 'insights';
  if (pathname.includes('/settings')) return 'settings';
  return 'map';
}

export function missionNavForSection(section: MissionSection): MissionNavItem[] {
  if (section === 'map') return MISSION_NAV.filter((i) => i.section === 'map');
  return MISSION_NAV.filter((i) => i.section === section);
}
